module.exports = __webpack_public_path__ + "static/media/chennai.1acaacb7.svg";